<template>
  <v-data-table
    v-bind="tableProps"
    dense
    :headers="headers"
    :items="data"
    :loading="loading"
    @click:row="onRowClick"
  >
    <template v-slot:[`item.warehouse_id`]="{ item }">
      {{ item.warehouse_id[1] }}
    </template>
    <template v-slot:[`item.promotion_id`]="{ item }">
      {{ item.promotion_id.description }}
    </template>
    <template v-slot:[`item.sale_count`]="{ item }">
      {{ item.sale_count.value }}
    </template>
  </v-data-table>
</template>

<script>
import { inject } from "vue-demi";
import { useDataTable } from "@/composables/api/data-table.js";

export default {
  setup() {
    const { data, loading, headers, tableProps } = useDataTable("promotion");

    const showOnMap = inject("showOnMap");

    const onRowClick = item => {
      showOnMap({
        measure: "promotion",
        warehouse_id: item.warehouse_id[0],
        promotion_id: item.promotion_id.id
      });
    };

    return {
      data,
      loading,
      headers,
      onRowClick,
      tableProps
    };
  }
};
</script>

<style></style>
